<template>

	<pharmacy-detail-page></pharmacy-detail-page>

</template>


<script>
import pharmacyDetailPage from '../apotheken/pharmacy-detail-page';

export default {

	components: {
		pharmacyDetailPage,
	},

}
</script>

<style scoped></style>
